import styled, { css } from 'styled-components';

import { TextBodyBold, TextBodyNormal } from '@/core/components/Typography/Typography.styles';

import { TabsVariant } from './Tabs.types';

type WithVariant = { variant?: TabsVariant };

export const TabsContainer = styled.div<WithVariant>`
  display: flex;
  width: 100%;
  ${({ variant }) =>
    variant === TabsVariant.SECONDARY
      ? css`
          padding: 0 24px;
          background-color: ${({ theme }) => theme.colors.background.medium};
        `
      : css`
          align-items: center;
          gap: 20px;
        `}
`;

export const TabsListContainer = styled.ul<WithVariant & { withMore?: boolean }>`
  padding: 0;
  ${({ variant, withMore }) =>
    variant === TabsVariant.SECONDARY
      ? css`
          display: flex;
          flex: 1;
          margin: 0;
        `
      : css`
          max-width: ${withMore ? 'calc(100% - 62px)' : '100%'};
          margin: 0 -12px;
          white-space: nowrap;
        `}
`;

const activeItemElementStyles = css`
  content: '';
  position: absolute;
  right: 0;
  bottom: -10px;
  left: 0;
  height: 4px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.active};
  transition: background-color 0.25s ease;
  pointer-events: none;
`;

export const StyledTab = styled.li<WithVariant & { isActive: boolean }>`
  position: relative;
  list-style: none;
  cursor: pointer;
  ${({ variant }) =>
    variant === TabsVariant.SECONDARY
      ? css`
          display: inline-flex;
          flex: 1;
          justify-content: center;
          align-items: center;
          padding: 18px 12px;
        `
      : css`
          display: inline-block;
          max-width: 100%;
          padding: 0 12px 4px;
          white-space: nowrap;
        `}

  &::after {
    ${({ isActive }) => isActive && activeItemElementStyles}
    right: 12px;
    left: 12px;
    ${({ isActive, variant }) =>
      isActive &&
      variant === TabsVariant.SECONDARY &&
      css`
        bottom: 0;
        border-radius: 4px 4px 0 0;
      `}
  }
`;

export const StyledTabLabel = styled(TextBodyNormal)`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.secondaryText};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledTabBoldLabel = styled(TextBodyBold)`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.primaryText};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MoreTabsContainer = styled.div<{ isActive: boolean }>`
  position: relative;
  height: 24px;
  margin-left: auto;

  &::after {
    ${({ isActive }) => isActive && activeItemElementStyles}
  }
`;

export const MoreTabItemlabel = styled.span<{ isActive: boolean }>`
  font-weight: ${({ isActive }) => (isActive ? '700' : '400')};
`;
